export var attribute = {
    vtm3Banner: {
        banner: "vtm3-films-top-banner",
        button: "vtm3-films-banner-button",
    },
    vtmNieuwsBanner: {
        banner: "vtmnieuws-top-banner",
        button: "vtmnieuws-banner-button",
    },
    vtmGoBanner: {
        banner: "vtmgo-top-banner",
        button: "vtmgo-banner-button",
    },
    vtmGoPlusBanner: {
        banner: "vtmgo-plus-top-banner",
        button: "vtmgo-plus-banner-button",
    },
    hero: {
        listButton: "hero-mijnlijst-button",
        liveButton: "vtmgo-hero-live-button",
        demandButton: "vtmgo-hero-button",
    },
    banner: {
        banner: "banner",
        button: "banner-button",
        listButton: "banner-mijnlijst-button",
    },
    mainNav: {
        home: "home-main-nav",
        tickets: "tickets-main-nav",
        programmas: "programmas-main-nav",
        tvGids: "tvgids-main-nav",
        vtmGo: "vtmgo-main-nav",
        vtmShop: "vtmshop-main-nav",
        search: "search-main-nav",
    },
    errorPage: {
        search: "search-404-page",
    },
    brandsFooter: {
        vtmGo: "vtmgo-brand-button",
        vtmNieuws: "vtmnieuws-brand-button",
        vtmKids: "vtmkids-brand-button",
        vtmKoken: "vtmkoken-brand-button",
        vtmShop: "vtmshop-brand-button",
        vtmTickets: "vtmtickets-brand-button",
    },
    footerNav: {
        vtmGo: "vtmgo-footer-button",
        vtmNieuws: "vtmnieuws-footer-link",
        vtmKids: "vtmkids-footer-link",
        vtmKoken: "vtmkoken-footer-link",
        vtmTickets: "vtmtickets-footer-link",
        doeMee: "doe-mee-footer-link",
        adverteren: "adverteren-footer-link",
        route: "route-footer-link",
        jobs: "jobs-footer-link",
        programmas: "programmas-footer-link",
        tvGids: "tvgids-footer-link",
        vragen: "vragen-footer-link",
        nieuwsbrief: "nieuwsbrief-footer-link",
        facebook: "facebook-footer-link",
        instagram: "instagram-footer-link",
    },
    seasonLane: {
        episode: {
            card: "vtmgo-swimlane-episode-card",
            goButton: "vtmgo-swimlane-episode-button",
            listButton: "vtmgo-swimlane-mijnlijst-button",
        },
    },
    userBadge: {
        loggedOut: {
            navItem: "login-main-nav-logged-out",
            callToAction: "login-details-login-cta",
            register: "login-details-register-cta",
        },
        loggedIn: {
            navItem: "login-main-nav-logged-in",
            settings: "login-details-settings-cta",
            logout: "login-details-logout-cta",
        },
    },
};
